import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { getCalendarDateKey } from "../../utils/calendarDateKey";
import { savePreparationDraft } from "./preparationDraftService";

const localInput = (iso) => {
  const date = new Date(iso);
  return `${getCalendarDateKey(date)}T${date.toTimeString().slice(0, 5)}`;
};
const HandoverPeriodControl = ({
  period,
  coverage,
  childId,
  draftIdentity,
  canEdit,
  onSaved,
}) => {
  const [editing, setEditing] = useState(false);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  if (!period?.handover) return null;
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const save = async () => {
    if (!canEdit || saving) return;
    const from = new Date(start);
    const until = new Date(end);
    if (
      !Number.isFinite(from.getTime()) ||
      !Number.isFinite(until.getTime()) ||
      from > until ||
      until > new Date()
    ) {
      setError("Choose a valid start and end, ending no later than now.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await savePreparationDraft({
        childId,
        ...draftIdentity,
        handoverPeriod: {
          start: from.toISOString(),
          end: until.toISOString(),
          timeZone: zone,
        },
      });
      await onSaved?.();
      setEditing(false);
    } catch (failure) {
      setError(failure?.message || "The handover period could not be saved.");
    } finally {
      setSaving(false);
    }
  };
  return (
    <Box sx={{ mt: 1 }}>
      <Typography sx={{ fontSize: "0.82rem" }}>
        {period.reviewedPeriodText}
      </Typography>
      <Typography sx={{ fontSize: "0.78rem", color: "text.secondary" }}>
        {`${coverage?.recordCount || 0} care records in this period. ${coverage?.pendingCaptureCount || 0} saved captures still processing or awaiting review.`}
      </Typography>
      {canEdit && !editing ? (
        <Button
          onClick={() => {
            setStart(localInput(period.startDate));
            setEnd(localInput(period.endDate));
            setError("");
            setEditing(true);
          }}
        >
          Change covered period
        </Button>
      ) : null}
      {editing && canEdit ? (
        <Stack spacing={1} sx={{ mt: 1 }}>
          <TextField
            type="datetime-local"
            label={`Start (${zone})`}
            value={start}
            onChange={(event) => setStart(event.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            type="datetime-local"
            label={`End (${zone})`}
            value={end}
            onChange={(event) => setEnd(event.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <Stack direction="row">
            <Button disabled={saving} onClick={save}>
              Save period
            </Button>
            <Button disabled={saving} onClick={() => setEditing(false)}>
              Cancel
            </Button>
          </Stack>
        </Stack>
      ) : null}
      {error ? <Alert severity="error">{error}</Alert> : null}
    </Box>
  );
};
export default HandoverPeriodControl;
